<template>
  <div class="chat-display-page col-block width-full">
    <div class="chat-display-container col-block width-full">
      <div class="chat-display-block row-block flex-start" v-for="(chatData, cdindex) in chatDatas" :key="cdindex">
        <div v-if="chatData.msgType" class="avatar-block" :style="{ '--size': '40px' }">
          <img v-if="chatData.msgType === 'answer'" :src="require('../../assets/images/bot-avatar.svg')" alt="">
        </div>
        <div
          class="chat-display-content-container col-block"
          :class="[{
            'answer': 'flex-start',
            'question': 'flex-end'
          }[chatData.msgType]] || 'stretch'"
          :style="{ flex: 1, width: 0 }"
        >
          <template v-if="chatData.type === 'loading'">
            <div
              v-if="chatData.message"
              class="chat-display-content-block bot-answer col-block flex-start"
              v-html="chatData.message"
            ></div>
            <div v-else class="chat-display-content-block row-block bot-loading">
              <img :src="require('../../assets/images/upload.svg')" alt="" :style="{ height: '3em' }">
              <span class="shrink ellipsis" v-if="botStatus" :title="botStatus.message">{{ botStatus.message }}</span>
              <div :style="{ flex: 1 }"></div>
            </div>
          </template>
          <template v-else-if="chatData.type === 'stop'">
            <div class="chat-display-content-block bot-stop break-line">
              <span>{{ $t('COMPONENT.chat.display.___stopMsg') }}</span>
            </div>
          </template>
          <template v-else>
            <div v-if="chatData.msgType === 'question'" class="chat-display-content-block break-line">
              <span>{{ chatData.message }}</span>
            </div>
            <div
              v-else-if="chatData.msgType === 'answer'"
              class="chat-display-content-block bot-answer col-block flex-start"
              v-html="chatData.message"
            ></div>
          </template>
        </div>
        <div v-if="chatData.msgType" class="avatar-block" :style="{ '--size': '40px' }">
          <img v-if="chatData.msgType === 'question'" :src="avatarUrl" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import userPermission from '../../mixins/userPermission.vue'
import { sortData } from '../../constants/global/util'

export default {
  mixins: [
    userPermission
  ],
  props: {
    chats: {
      type: Array,
      default: () => []
    },
    botState: {
      type: String,
      default: () => ''
    },
    botChatData: {
      type: Object,
      required: true
    }
  },
  computed: {
    botStatus () {
      let status = (this.botChatData.status || [])
      return status[status.length - 1]
    },
    botAnswering () {
      return sortData(this.botChatData.message || [], data => data.timestamp, 'asc').map(data => data.data).join('')
    },
    chatDatas () {
      let botChats = {
        'loading': [
          {
            type: 'loading',
            msgType: 'answer',
            message: this.parseMDToHTML(this.botAnswering)
          }
        ],
        'stop': [
          {
            type: 'stop'
          }
        ]
      }[this.botState] || []
      return [
        ...this.chats.map(chat => (chat.msgType === 'answer' ? { ...chat, message: this.parseMDToHTML(chat.message) } : chat)),
        ...botChats
      ]
    }
  },
  methods: {
    parseMDToHTML (msg = '') {
      let html = marked.parse(msg)
      return DOMPurify.sanitize(html)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/display.vue